if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            // bind events 
            this.bindEvents(this.modalContent)

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog:not(.size-guide-modal)');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }

      bindEvents(modalContent) {
        // bind color events
        const colors = modalContent.querySelectorAll('.product-form__color-item a');
        if(colors.length > 0) {
          colors.forEach((color) => {
            color.addEventListener('click', (e) => {
              e.preventDefault();
  
              fetch(e.target.getAttribute('href'))
              .then((response) => response.text())
              .then((responseText) => {
                const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                const productElement = responseHTML.querySelector('product-info');
  
                this.preprocessHTML(productElement);
                HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
  
                // bind events
                this.bindEvents(this.modalContent)
  
                if (window.Shopify && Shopify.PaymentButton) {
                  Shopify.PaymentButton.init();
                }
                if (window.ProductModel) window.ProductModel.loadShopifyXR();
  
              });
            })
          })
        }
      }
    }
  );
}

if(!customElements.get('qv-product-media-carousel')) {
  class ProductMediaCarousel extends HTMLElement {
    constructor() {
      super();

      this.slider = null;
      this.options = {}
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.options = {
        slidesPerView: 'auto',
        spaceBetween: 10,
        navigation: {
          prevEl: this.querySelector('.swiper-button-prev'),
          nextEl: this.querySelector('.swiper-button-next'),
        }
      };

      this.slider = new Swiper(
        this.querySelector('[data-slider]'), // Pass the slider element
        this.options, // Pass the configuration options
      );
    }

    connectedCallback() {
      this.initSlider()
    }
  }
  customElements.define('qv-product-media-carousel', ProductMediaCarousel)
}


const modalCloses = document.querySelectorAll('#modal .modal__close-icon, .drawer-overlay');

modalCloses.forEach((modalClose) => {
  modalClose.addEventListener('click', () => {
    const modalWrapper = document.querySelector('#modal');
    if(modalWrapper.querySelectorAll('.size-guide-tab-container').length > 0) {
      modalWrapper.classList.remove('is-visible');
      modalWrapper.querySelector('.modal__content').innerHTML = '';
      document.querySelector('.drawer-overlay').classList.remove('is-active');
      document.querySelector('.drawer-overlay__inner').classList.remove('is-visible')
    }
  })
});